import React from 'react';
import WorkDayDashboard from '../components/workday/WorkDayDashboard';
import './CaregiverDashboard.css';

// Negovatelj (caregiver) - "Moj radni dan" sa zadacima nege.
const CaregiverDashboard = () => (
  <div className="caregiver-dashboard">
    <WorkDayDashboard tasksEndpoint="/api/Task/caregiver-tasks" />
  </div>
);

export default CaregiverDashboard;
